export default __webpack_public_path__ + "static/media/spt25.3f464308.jpg";